import { createApp } from "vue";
import store from "./store";
import { openobserveRum } from "@openobserve/browser-rum";
import { openobserveLogs } from "@openobserve/browser-logs";
// require("./bootstrap");
// import { parse } from "fast-xml-parser";

import App from "./App.vue";
// import axios from "axios";
import router from "./router";
import { createI18n } from "vue-i18n";
// import Vue3TouchEvents from "vue3-touch-events";
// import VueSplide from "@splidejs/vue-splide";
import uz from "./locales/uz.json";
import ru from "./locales/ru.json";
let lang = localStorage.getItem("lang") ? localStorage.getItem("lang") : "ru";
const i18n = createI18n({
    legacy: true,
    locale: lang,
    fallbackLocale: "ru",
    messages: {
        ru: ru,
        uz: uz,
    },
});

// if ("serviceWorker" in navigator) {
//     navigator.serviceWorker
//         .register("https://tvcom.uz/serviceWorker.js", {})
//         .then(
//             function(registration) {
//                 // console.log('ServiceWorker registration successful with scope: ', registration.scope);
//             },
//             function(err) {
//                 console.log("ServiceWorker registration failed: ", err);
//             }
//         );
// }

const app = createApp(App);
// app.config.errorHandler = (err, vm, info) => {
//     if (vm.$router) {
//         store.commit("updateError", true);
//     }
// };
// app.config.globalProperties.$axios = axios;
// const parsebnh = parse("../assets/all_mgg.xml");
// console.log(parsebnh);
app.use(i18n);
app.use(router);
app.use(store);
// app.use(Vue3TouchEvents);
// app.use(VueSplide);

app.mount("#app");
const token = localStorage.getItem("token");
const observLogs = () => {
    const isDeveloper = process.env.NODE_ENV === "development";
    if (isDeveloper) return;
    try {
        const options = {
            clientToken: "rumDVkU82JGjI7IoA3G",
            applicationId: "www",
            site: "log.tvcom.uz",
            service: "tvcom",
            env: "production",
            version: "0.0.1",
            organizationIdentifier: "default",
            apiVersion: "v1",
        };

        openobserveRum.init({
            applicationId: options.applicationId, // required, any string identifying your application
            clientToken: options.clientToken,
            site: options.site,
            organizationIdentifier: options.organizationIdentifier,
            service: options.service,
            env: options.env,
            version: options.version,
            trackResources: true,
            trackLongTasks: true,
            trackUserInteractions: true,
            apiVersion: options.apiVersion,
            defaultPrivacyLevel: "allow", // 'allow' or 'mask-user-input' or 'mask'. Use one of the 3 values.
        });

        openobserveLogs.init({
            clientToken: options.clientToken,
            site: options.site,
            organizationIdentifier: options.organizationIdentifier,
            service: options.service,
            env: options.env,
            version: options.version,
            forwardErrorsToLogs: true,
            insecureHTTP: options.insecureHTTP,
            apiVersion: options.apiVersion,
        });

        openobserveRum.startSessionReplayRecording();
        const abonement = localStorage.getItem("abonement");
        if (token && abonement) {
            openobserveRum.setUser({
                id: abonement,
                name: "abonement",
                email: abonement,
            });
        }
    } catch (error) {
        console.log(error);
    }
};
observLogs();
